export const JSON_Bank_Ifcs1 = {
    "code": "0x0200",
    "message": "Record fetched successfully.",
    "status": "SUCCESS",
    "data": {
        "requestId": "VIFC1047608942787599157D",
        "ifsc": "PYTM0123456",
        "currentStatus": "FOUND",
        "response": {
            "branch": "Noida Branch",
            "address": "B-121, Sector-5,Noida-201301",
            "city": "NOIDA",
            "state": "UTTAR PRADESH",
            "bankName": "Paytm Payments Bank",
            "bankCode": "PYTM"
        }
    }
};

export const JSON_Bank_Ifcs2 = {
    
        "code": "0x0200",
        "message": "Record fetched successfully.",
        "status": "SUCCESS",
        "data": {
            "requestId": "VIFC10474859058579364349",
            "ifsc": "PYTM0120000",
            "currentStatus": "NOT_FOUND"
        }
    
}

export const JSON_Bank_Ifcs3 = {
    
        "code": "0x0202",
        "status": "FAILURE",
        "message": "Failure",
        "data":{
                "requestId":"VIFC10474859058579364349",
                "currentStatus":"FAILED",
            }
        
    
}